import api from "./api";

const CHUNK_SIZE = 5 * 1024 * 1024; // 5MB per chunk — small requests avoid proxy timeouts

// Uploads a (potentially large) video in chunks so slow connections / proxy
// request timeouts don't break the upload. Returns { path, url }.
export async function uploadVideoChunked(file, onProgress) {
    const { data: init } = await api.post("/admin/upload-video/init");
    const uploadId = init.upload_id;
    const totalChunks = Math.max(1, Math.ceil(file.size / CHUNK_SIZE));

    for (let i = 0; i < totalChunks; i++) {
        const start = i * CHUNK_SIZE;
        const chunk = file.slice(start, start + CHUNK_SIZE);
        const fd = new FormData();
        fd.append("upload_id", uploadId);
        fd.append("chunk_index", i);
        fd.append("file", chunk, file.name || "chunk");
        await api.post("/admin/upload-video/chunk", fd, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        if (onProgress) onProgress(Math.min(99, Math.round(((i + 1) / totalChunks) * 100)));
    }

    const fd = new FormData();
    fd.append("upload_id", uploadId);
    fd.append("filename", file.name || "video.mp4");
    const { data } = await api.post("/admin/upload-video/complete", fd, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    if (onProgress) onProgress(100);
    return data;
}
